export const apiConfigs = {
  firstClass: {
    timeout: 4000,
    retry: {
      limit: 3,
      methods: ['get', 'post']
    }
  },

  secondClass: {
    timeout: 5000,
    retry: {
      limit: 0
    }
  },
  specific: route => {
    const configPerRoute = [
      {
        path: 'm/addChunk',
        config: {
          timeout: 4000,
          retry: { limit: 3 }
        }
      }
    ]

    return configPerRoute.find(configPerRoute =>
      route.includes(configPerRoute.path)
    )
  }
}

export function getApiClientConfig(route) {
  const routeWithoutVersionPrefix = route.replace('v1/', '')
  const specificRouteConfig = apiConfigs.specific(routeWithoutVersionPrefix)

  if (specificRouteConfig) {
    return specificRouteConfig.config
  }

  switch (true) {
    case routeWithoutVersionPrefix.startsWith('a/'):
    case routeWithoutVersionPrefix.startsWith('m/'):
    case routeWithoutVersionPrefix.startsWith('i/'):
    case routeWithoutVersionPrefix.startsWith('c/'):
      return apiConfigs.firstClass
    case routeWithoutVersionPrefix.startsWith('b/'):
    case routeWithoutVersionPrefix.startsWith('d/'):
    case routeWithoutVersionPrefix.startsWith('f/'):
    case routeWithoutVersionPrefix.startsWith('s/'):
    case routeWithoutVersionPrefix.startsWith('t/'):
    case routeWithoutVersionPrefix.startsWith('u/'):
    case routeWithoutVersionPrefix.startsWith('x/'):
      return apiConfigs.secondClass
    default:
      throw new Error(`Domain/Route is not handled (${route})`)
  }
}
